module.exports = __webpack_public_path__ + "img/notice.e7648ec.gif";